
export class Dist {
  value: number
  constructor(feet: number, inches: number){
    this.value = feet + (inches/12);
  }

  get ft (){
    return this.toFeet()
  }
  get in () {
    return this.toInches()
  }

  static zero: Dist = new Dist(0,0);

  /**Returns the distance value in feet. */
  toFeet(): number {
    return this.value;
  }
  /**Returns the distance value in inches. */
  toInches(): number {
    return this.value * 12;
  }
  /**Returns the distance as a string in decimal feet. */
  toFeetString(decimal: number): string{
    return `${this.ft.toFixed(decimal)}'`;
  }
  /**Returns the distance as a string in decimal inches. */
  toInchString(decimal: number): string{
    return `${this.in.toFixed(decimal)}"`;
  }
  /**Returns new distance from input feet */
  static feet (feet: number): Dist {
    return new Dist(feet, 0)
  }
  /**Returns new distance from input inches */
  static inches (inches: number): Dist {
    return new Dist(0, inches)
  }

  /**Custom method to convert to json */
  toJSON(): string {
    return this.value.toFixed(5)
  }

}